export const getDataColor = (status) => {
  return status === 'ATENDIDA' ? '#5cb85c' : '#d9534f';
};
